module.exports = __webpack_public_path__ + "img/NewsCenter_pic7.37d3c3f2.png";